export default __webpack_public_path__ + "static/media/High Priest's Ring of Wisdom.ee9a29b0.jpg";